var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMoneyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 107.05 103.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#212529;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.48,62.65H111.09a3.05,3.05,0,0,0-3,3.09v8.5a3.05,3.05,0,0,0,3,3.09h14.39a3.05,3.05,0,0,0,3-3.09v-8.5A3.05,3.05,0,0,0,125.48,62.65Zm-10,10.56a3.07,3.07,0,1,1,3.07-3.06A3.06,3.06,0,0,1,115.5,73.21Z",
    transform: "translate(-21.48 -23.38)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.06,60.13l20.46.06s-.08-14.9,0-16.48c.14-5.08-3.92-5.58-3.92-5.58H117.4s-1.25-7.34-2.25-10.84c-1.59-5.33-8.75-3.66-8.75-3.66s-51.76,13.1-59.67,14c-5.3.6-6,4.06-6.17,6.25-.65,8.41-.49,32.62-.58,33.62,31-3,30.92,24,30.92,24s42.06.06,52.44.06c5.56,0,5.16-5,5.16-5l0-17s-20.37,0-20.92,0a2,2,0,0,1-2.1-1.94s0-11-.06-14.33C105.65,60.13,108.06,60.13,108.06,60.13ZM59.73,38S93.11,30,104.21,27.21c6.05-1.49,7-.21,7.62.92s2,9.84,2,9.84Z",
    transform: "translate(-21.48 -23.38)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.14,79.28A23.67,23.67,0,1,0,68.81,103,23.66,23.66,0,0,0,45.14,79.28ZM60,104.62H47V118.3H43.3V104.62h-13v-3.46h13V87.61H47v13.55H60Z",
    transform: "translate(-21.48 -23.38)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMoneyIcon);
export default __webpack_public_path__ + "static/media/add_money_icon.dbe615400498487d426f6893002e3177.svg";
export { ForwardRef as ReactComponent };